import React from 'react';

const Copyright = () => {
  return (
    <p>© 2025 Orhan Yılmaz. <span className="text-green">Alle Rechte vorbehalten.</span></p>
  );
};

export default Copyright;
